(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    class BuyButtons extends HTMLElement {
		connectedCallback() {
			this.section = this.closest('.shopify-section');
			this.button = this.querySelector('button[name="add"]');
			this.label = this.button?.querySelector('[data-label]');

			const checkoutForm = this.button?.form?.closest('checkout-form');
			this.skipCart = checkoutForm?.dataset.skipCart === 'true';

			if (this.label) {
				this.label.textContent = this.#resolveLabel(!this.button.disabled);
			}

			this.section?.addEventListener('variant:change', this.#onVariantChange);
		}

		#resolveLabel(available) {
			if (!available) return window.theme.strings.soldOut;
			return this.skipCart ? 'Purchase' : 'Add to Cart';
		}

		#onVariantChange = e => {
			if (!this.button) return;
			const { available } = e.detail;
			this.button.disabled = !available;
			if (this.label) this.label.textContent = this.#resolveLabel(available);
		};
	}

	if (!customElements.get('buy-buttons')) {
		customElements.define('buy-buttons', BuyButtons);
	}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["group"] && !Shopify.designMode) return;
  try {
    class CheckoutForm extends HTMLElement {
		constructor() {
			super();
			this.form = this.querySelector('form');
			this.skipCart = this.dataset.skipCart === 'true';
			this.button = this.querySelector('button[name="add"]');
			this.label = this.button?.querySelector('[data-label], span');
			this.originalLabel = this.label?.textContent || '';
			this.alert = this.querySelector('.alert');

			this.form?.addEventListener('submit', this.#onSubmit);
		}

		#onSubmit = async e => {
			e.preventDefault();
			this.#setLoading(true);

			try {
				if (this.skipCart) {
					const clearRes = await fetch('/cart/clear.js', {
						method: 'POST',
						headers: { 'Accept': 'application/javascript' }
					});
					if (!clearRes.ok) throw new Error('Cart clear failed.');
				}

				const addRes = await fetch('/cart/add.js', {
					method: 'POST',
					headers: { 'Accept': 'application/javascript' },
					body: new FormData(this.form)
				});

				if (!addRes.ok) {
					const err = await addRes.json().catch(() => ({}));
					throw new Error(err.description || 'Failed to add to cart.');
				}

				if (this.skipCart) {
					location.href = '/checkout';
					return;
				}

				await this.#updateCartCount();
				this.#flashSuccess();
			} catch (err) {
				console.error(err);
				this.#setLoading(false);
				this.#showError(err.message);
			}
		};

		async #updateCartCount() {
			try {
				const cart = await fetch('/cart.js').then(r => r.json());
				document.querySelectorAll('.badge-quantity').forEach(el => {
					el.textContent = cart.item_count;
				});
				document.dispatchEvent(new CustomEvent('cart:updated', {
					detail: { item_count: cart.item_count }
				}));
			} catch {}
		}

		#flashSuccess() {
			if (this.label) this.label.textContent = 'Added ✓';
			if (this.button) this.button.disabled = false;
			setTimeout(() => {
				if (this.label) this.label.textContent = this.originalLabel;
			}, 1500);
		}

		#showError(msg) {
			if (!this.alert) return;
			this.alert.textContent = msg;
			this.alert.className = 'alert alert-danger';
			setTimeout(() => this.alert.classList.add('d-none'), 4000);
		}

		#setLoading(isLoading) {
			if (!this.button) return;
			this.button.disabled = isLoading;
			if (this.label) {
				this.label.textContent = isLoading ? 'Adding...' : this.originalLabel;
			}
		}
	}

	if (!customElements.get('checkout-form')) {
		customElements.define('checkout-form', CheckoutForm);
	}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["price"] && !Shopify.designMode) return;
  try {
    class ProductPrice extends HTMLElement {
		constructor() {
			super();
			this.section = this.closest('.shopify-section');
			this.current = this.querySelector('.product-price-current');
			this.compare = this.querySelector('.product-price-compare');

			this.unitPrice = Number(this.dataset.price) || 0;
			this.unitCompareAtPrice = Number(this.dataset.compareAtPrice) || 0;

			const quantityInput = this.section?.querySelector('input[name="quantity"]');
			this.quantity = quantityInput ? Math.max(1, parseInt(quantityInput.value, 10) || 1) : 1;

			this.section?.addEventListener('variant:change', this.#onVariantChange);
			this.section?.addEventListener('input', this.#onSectionInput);
		}

		#onVariantChange = e => {
			const { price, compareAtPrice } = e.detail;
			this.unitPrice = Number(price) || 0;
			this.unitCompareAtPrice = Number(compareAtPrice) || 0;
			this.#render();
		};

		#onSectionInput = e => {
			if (e.target?.name !== 'quantity') return;
			const value = parseInt(e.target.value, 10);
			this.quantity = value > 0 ? value : 1;
			this.#render();
		};

		#render = () => {
			const total = this.unitPrice * this.quantity;
			const compareTotal = this.unitCompareAtPrice * this.quantity;
			const onSale = this.unitCompareAtPrice && this.unitCompareAtPrice > this.unitPrice;

			this.current.innerHTML = window.formatMoney(total);
			this.classList.toggle('product-price-sale', onSale);

			if (this.compare) {
				if (onSale) {
					this.compare.innerHTML = window.formatMoney(compareTotal);
					this.compare.removeAttribute('hidden');
				} else {
					this.compare.innerHTML = '';
					this.compare.setAttribute('hidden', '');
				}
			}
		};
	}

	if (!customElements.get('product-price')) {
		customElements.define('product-price', ProductPrice);
	}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["quantity-selector"] && !Shopify.designMode) return;
  try {
    class QuantityInput extends HTMLElement {
		constructor() {
			super();
			this.inputElement = this.querySelector('input');
			this.#prepareEventHandlers();
		}

		#prepareEventHandlers() {
			const minusButton = this.querySelector('[name="minus"]');
			const plusButton = this.querySelector('[name="plus"]');

			[minusButton, plusButton].forEach((button) => {
				button.addEventListener('click', this.#onButtonClick);
			});
		}

		#onButtonClick = (event) => {
			event.preventDefault();
			const currentValue = parseInt(this.inputElement.value);
			const newValue = event.currentTarget.name === 'plus' ? currentValue + 1 : currentValue - 1;
			this.inputElement.value = newValue > 0 ? newValue : 1;
			this.inputElement.dispatchEvent(new Event('input', { bubbles: true }));
		};
	}

	if (!customElements.get('quantity-input')) {
		customElements.define('quantity-input', QuantityInput);
	}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["variant-picker"] && !Shopify.designMode) return;
  try {
    class ProductInputs extends HTMLElement {
		constructor() {
			super();
			this.section = this.closest('.shopify-section');
			this.hiddenVariantInput = this.section.querySelector(`input[name="id"]`);
			this.inputElement = this.querySelector(`[name="id"]`);
			this.productUrl = this.dataset.url;
			this.addEventListener('change', this.#onChange);
		}

		#onChange = () => {
			const option = this.inputElement.selectedOptions[0];
			const variantId = this.inputElement.value;

			this.hiddenVariantInput.value = variantId;

			if (history.pushState && this.productUrl) {
				const newUrl = `${location.protocol}//${location.host}${location.pathname}?variant=${variantId}`;
				window.history.replaceState({ path: newUrl }, '', newUrl);
			}

			this.section.dispatchEvent(new CustomEvent('variant:change', {
				detail: {
					id: Number(variantId),
					price: Number(option.dataset.price),
					compareAtPrice: Number(option.dataset.compareAtPrice) || 0,
					available: option.dataset.available === 'true'
				}
			}));
		};
	}

	if (!customElements.get('product-inputs')) {
		customElements.define('product-inputs', ProductInputs);
	}
  } catch(e) { console.error(e); }
})();

})();
